/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StarredViewCompany
 */
export interface StarredViewCompany {
  /**
   *
   * @type {string}
   * @memberof StarredViewCompany
   */
  starredObjectId?: string | null;
  /**
   *
   * @type {string}
   * @memberof StarredViewCompany
   */
  reason?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof StarredViewCompany
   */
  isStarred: boolean;
}

/**
 * Check if a given object implements the StarredViewCompany interface.
 */
export function instanceOfStarredViewCompany(
  value: object,
): value is StarredViewCompany {
  if (!("isStarred" in value) || value["isStarred"] === undefined) return false;
  return true;
}

export function StarredViewCompanyFromJSON(json: any): StarredViewCompany {
  return StarredViewCompanyFromJSONTyped(json, false);
}

export function StarredViewCompanyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StarredViewCompany {
  if (json == null) {
    return json;
  }
  return {
    starredObjectId:
      json["starredObjectId"] == null ? undefined : json["starredObjectId"],
    reason: json["reason"] == null ? undefined : json["reason"],
    isStarred: json["isStarred"],
  };
}

export function StarredViewCompanyToJSON(json: any): StarredViewCompany {
  return StarredViewCompanyToJSONTyped(json, false);
}

export function StarredViewCompanyToJSONTyped(
  value?: StarredViewCompany | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    starredObjectId: value["starredObjectId"],
    reason: value["reason"],
    isStarred: value["isStarred"],
  };
}
